import { createStore } from 'vuex'

import ui from './ui'
import user from './user'
import loggers from './loggers'
import admin from './admin'

const store = createStore({
  modules: {
    ui,
    user,
    loggers,
    admin,
  },
})

export default store